'use client'

import { useState } from 'react'
import Link from 'next/link'
import { useAuth } from '@clerk/nextjs'
import { LogoMark, Text } from '@/design-system'
import { AuthModal } from '@/components/auth/AuthModal'

type AuthMode = 'sign-in' | 'sign-up'

const CTA_BTN_LAYOUT: React.CSSProperties = {
  color: 'var(--ink)',
  background: 'var(--accent)',
  border: 'var(--border-w) solid var(--ink)',
  boxShadow: 'var(--shadow-sm)',
  padding: '8px 14px',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6
}

const GHOST_BTN_LAYOUT: React.CSSProperties = {
  color: 'var(--ink)',
  background: 'var(--paper)',
  border: 'var(--border-w) solid var(--ink)',
  boxShadow: 'var(--shadow-sm)',
  padding: '8px 14px',
  cursor: 'pointer'
}

const CTA_LINK_LAYOUT: React.CSSProperties = {
  ...CTA_BTN_LAYOUT,
  textDecoration: 'none'
}

export function MarketingNav() {
  const { isSignedIn } = useAuth()
  const [authModal, setAuthModal] = useState<AuthMode | null>(null)

  return (
    <>
      <header
        className="st-marketing-nav"
        style={{
          borderBottom: 'var(--border-w) solid var(--ink)',
          background: 'var(--paper)',
          padding: '22px 36px',
          display: 'flex',
          alignItems: 'center',
          gap: 16
        }}>
        <Link
          href="/"
          className="st-logo-mark"
          style={{
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10
          }}>
          <LogoMark />
          <Text variant="h2" as="span" color="ink">
            SnapTransfer
          </Text>
        </Link>
        <nav className="st-marketing-nav-secondary" style={{ display: 'flex', gap: 4, marginLeft: 12 }}>
          <Link href="/#pricing" style={{ textDecoration: 'none', padding: '6px 10px' }}>
            <Text variant="tag" as="span" color="ink" style={{ letterSpacing: '0.16em' }}>
              Pricing
            </Text>
          </Link>
        </nav>
        <div style={{ flex: 1 }} />
        {isSignedIn ? (
          <Link href="/send" style={CTA_LINK_LAYOUT}>
            <Text variant="h4" as="span" style={{ fontSize: 13, letterSpacing: '-0.01em' }}>
              Dashboard →
            </Text>
          </Link>
        ) : (
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              type="button"
              className="st-marketing-nav-signin"
              style={GHOST_BTN_LAYOUT}
              onClick={() => setAuthModal('sign-in')}>
              <Text variant="h4" as="span" style={{ fontSize: 13, letterSpacing: '-0.01em' }}>
                Sign in
              </Text>
            </button>
            <Link href="/sign-up" style={CTA_LINK_LAYOUT}>
              <Text variant="h4" as="span" style={{ fontSize: 13, letterSpacing: '-0.01em' }}>
                Get started →
              </Text>
            </Link>
          </div>
        )}
      </header>
      {authModal !== null && <AuthModal mode={authModal} onClose={() => setAuthModal(null)} />}
    </>
  )
}
